import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Util } from '@libs/utilities/util';
import { Subject } from 'rxjs';

import { AddonFacebookChatScript } from './facebook-chat';
import { AddonFacebookLoginScript } from './facebook-login';
import { IAddonFacebookSdkConfig, TypeAddonWindowFacebookSdk } from './facebook.interface';
import { IAddonAddOnScriptScript, EnumAddonPageAddonInjection } from '../../shared/page-addons.interface';


@Injectable()
export class AddonFacebookScript implements IAddonAddOnScriptScript {

	//** Window object to access the script functions */
	private readonly window: TypeAddonWindowFacebookSdk;

	//** Helper Variables */
	isPluginLoaded: boolean = false;

	constructor(
		@Inject(EnumAddonPageAddonInjection.FacebookSocialConfig)
		private config				: IAddonFacebookSdkConfig,
		@Inject(DOCUMENT)
		private document			: Document,
		private facebookLoginScript	: AddonFacebookLoginScript,
		private facebookChatScript	: AddonFacebookChatScript
	) {
		//0 - set the window object
		this.window = this.document.defaultView as TypeAddonWindowFacebookSdk;

		//1 - create the subject (gets triggered by the injected script)
		this.window.FBChatOnLoad$ 		= new Subject<void>();
		this.window.FBLoginOnSubmit$ 	= new Subject<string>();
	}


	create(): AddonFacebookScript {

		//0 - check if config is set
		if (Util.String.isEmpty(this.config.pageId)) throw new Error(`AddonFacebookLoginService => setup => FATAL ERROR: the facebookAppId of "${this.config.pageId}" can not be empty`);

		//1 - check if fb chat is enabled
		if (this.config.customerChat.enable) this.facebookChatScript.create();

		//2 - check if fb login is enabled
		if (this.config.webLogin) this.facebookLoginScript.create();
		return this;
	}
}
